import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-body py-5 text-center" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "accordion-header card-header" }
const _hoisted_5 = ["data-bs-target", "aria-expanded", "aria-controls"]
const _hoisted_6 = { class: "m-0" }
const _hoisted_7 = { class: "badge bg-secondary me-3" }
const _hoisted_8 = { class: "flex-fill" }
const _hoisted_9 = { class: "m-0 fs-7 fst-italic" }
const _hoisted_10 = { class: "m-0 fs-7 fst-italic" }
const _hoisted_11 = {
  key: 0,
  class: "my-1"
}
const _hoisted_12 = { class: "m-0 fs-7 fst-italic" }
const _hoisted_13 = ["id", "data-bs-parent"]
const _hoisted_14 = { class: "accordion-body" }
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = { class: "card-body d-flex" }
const _hoisted_17 = { class: "m-0 p-0 pe-3 me-3 border-end d-flex align-items-center" }
const _hoisted_18 = { class: "m-0" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "d-flex justify-content-end gap-2 pe-3" }
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_payment_option_modal = _resolveComponent("payment-option-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.currentOptions || (_ctx.currentOptions && _ctx.currentOptions?.length == 0))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-money-bill opacity-50 m-0" }, null, -1)),
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mb-2" }, "Aún no tienes formas de pago configurada", -1)),
            _createVNode(_component_payment_option_modal, {
              "button-class": "m-auto d-flex align-items-center",
              "new-event": _ctx.newEvent,
              "event-id": _ctx.eventId,
              onOnSetPaymentOptions: _ctx.savePaymentOptions
            }, null, 8, ["new-event", "event-id", "onOnSetPaymentOptions"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "accordion mt-4",
      id: `accordion-payment-options-${_ctx.id}`
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentOptions, (option, ind) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "accordion-item w-100 align-items-stretch card",
          key: option.id
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["align-items-center d-flex", ind == 0 ? '' : 'collapsed']),
              type: "button",
              "data-bs-toggle": "collapse",
              "data-bs-target": `#collapse-${option.id}`,
              "aria-expanded": ind == 0 ? 'true' : 'false',
              "aria-controls": `collapse-${option.id}`
            }, [
              _createElementVNode("h4", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(ind + 1), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h6", null, [
                  _createElementVNode("strong", null, _toDisplayString(option.name), 1)
                ]),
                _createElementVNode("p", _hoisted_9, [
                  _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Descripción: ", -1)),
                  _createTextVNode(_toDisplayString(option.description), 1)
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "my-1" }, null, -1)),
                _createElementVNode("p", _hoisted_10, " Cuenta con " + _toDisplayString(option.options.length) + " descuentos que serán aplicados a las comisiones del usuario al momento de realizar la compra. ", 1),
                (option.start || option.end)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_11))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_12, [
                  (option.start)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[3] || (_cache[3] = _createTextVNode("Comenzará a publicarse a partir de ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.date(option.start.seconds * 1000)), 1),
                        _cache[4] || (_cache[4] = _createTextVNode(".", -1))
                      ], 64))
                    : _createCommentVNode("", true),
                  (option.end)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[5] || (_cache[5] = _createTextVNode("Dejará de publicarse el ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.date(option.end.seconds * 1000)), 1),
                        _cache[6] || (_cache[6] = _createTextVNode(".", -1))
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-chevron-down ms-3" }, null, -1))
            ], 10, _hoisted_5)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["accordion-collapse collapse card-body", ind == 0 ? 'show' : '']),
            id: `collapse-${option.id}`,
            "data-bs-parent": `#accordion-payment-options-${_ctx.id}`
          }, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payment_discounts(option.options ?? []), (opt, ind) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "card mb-3 payment-option-item",
                    key: ind
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("h5", _hoisted_17, _toDisplayString(ind + 1), 1),
                      _createElementVNode("p", _hoisted_18, [
                        _createElementVNode("span", {
                          innerHTML: _ctx.option_type_html(opt)
                        }, null, 8, _hoisted_19),
                        _cache[9] || (_cache[9] = _createTextVNode(" se descontará el ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(opt.percentage) + "%", 1),
                        _cache[10] || (_cache[10] = _createTextVNode(" del valor total de la cuenta ", -1))
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  onClick: () => _ctx.remove(option)
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("i", { class: "fas fa-trash" }, null, -1),
                  _createTextVNode(" Eliminar ", -1)
                ]))], 8, _hoisted_21),
                (_ctx.currentEventId)
                  ? (_openBlock(), _createBlock(_component_payment_option_modal, {
                      key: 0,
                      option: option,
                      id: option.id,
                      "event-id": _ctx.currentEventId,
                      onOnSetPaymentOptions: _ctx.savePaymentOptions
                    }, null, 8, ["option", "id", "event-id", "onOnSetPaymentOptions"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 10, _hoisted_13)
        ]))
      }), 128)),
      _cache[12] || (_cache[12] = _createElementVNode("hr", null, null, -1))
    ], 8, _hoisted_3)
  ], 64))
}